module.exports = __webpack_public_path__ + "img/robinhood.1c1e905e.svg";